import {Tests} from '../tests/tests';

export class ClientManagement{

    clientDesc: string;
    clientId: number;
    clientName: string;
    createdBy: string;
    createdTimestamp: string;
    id: number;
    isActive: boolean;
    updatedBy: string;
    updatedTimestamp: string;

}

export class CreateClientsRequest{

    clientDesc: string;
    clientName: string;
    createdBy: string;
    tests: Tests;
}

export class UpdateClientsRequest{

    clientDesc: string;
    clientId: string;
    clientName: string;
    createdBy: string;
    tests: Tests;
}
